module.exports = __webpack_public_path__ + "static/media/mdi_reddit.cc0c9265.svg";